module.exports = __webpack_public_path__ + "static/media/contratoNDA.20659cff.svg";